module.exports = __webpack_public_path__ + "img/pic1.5ee86a21.png";